var DataModule = ( function( ) {
	
	var chartId;
	var chartConfig;
	var currWidth; //width of window
	var currMeasure; //current responsive mesasure
	var responsive = { //responsive measurements
		mobile: 375, //px
		tablet: 1130
	};

	//HTML queries
	var $ = jQuery;
	var $container;
	var $form;
	var $demographicChart;
	var $nonDemographicChart;
	var $nonDemographicBars;
	var $demographicBars;
	var $nonDemographicTooltip;
	var $demographicTooltip;
	var $toggles;
	var $checkboxes;
	var demographicCodesArray;
	var $nonDemoPictoContainer;
	var $demoPictoContainer;

	var hasBeenInitialized = false;
		

	var firstTimeAnimated = false;

	//indicates what bar is being hovered (for tooltip)
	var hoveredHorizontalBar = null;
	var hoveredVerticalBar = null;

	//indicates if pictographic chart has been animated
	var pictoHasBeenAnimated_demo = false;
	var pictoHasBeenAnimated_nondemo = false;

	//only for type 6
	var demoLabelsArray = [];
	var activeDemoCheckboxGroup;

	//For vertical bars only, indicates the index of what dataset item we're hovering over 
	var currentlyHoveredItemIndex;

	//instances of bars
	var instances = [];

	//stores the legends that goes at the bottom of the chart
	var legends = [];

	var nonDemographicChartType;
	var demographicChartType;

	//private methods start with _

	/**
		Checks if an element is visible in the viewport
	*/
	function _checkVisible(elm) {
		var rect = elm.getBoundingClientRect();
		var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
		return !(rect.bottom < -300 || rect.top - viewHeight >= -300);
	}

	function _initialize() {

		hasBeenInitialized = true;

		if ($form.find("select[name=demo]").val().length) {
			_updateVerticalCharts();
		} else {
			_updateHorizontalCharts();
		}
	}

	/** 
		Sets the currentmesurement variable to reorder things
		on the html
	*/
	function _calculateMeasurements(w) {
		var currWidth = $(w).width();
		if(currWidth > responsive.tablet){
			currMeasure = "desktop";
		}else if (currWidth <= responsive.tablet && currWidth > responsive.mobile){
			currMeasure = "tablet";
		}else if(currWidth <= responsive.mobile){
			currMeasure = "mobile";
		}
	}

	function _saveChartInstances(instance, demogroup) {
		if(chartConfig.type === 6 && currentlyShownChart() == "vertical"){
			//disaggregated by me dice cual es el array de arrays a borrar
			//si no hay un active checbox, entonces borrar todas
			if(!instances[demogroup]){
				 instances[demogroup] = [];
			};
			instances[demogroup][instances[demogroup].length] = instance;
		}else{
			instances[instances.length] = instance;
		}
	}

	/**
		Returns the columns and the column suppressed to be used on a chart,
		because of the way the charts works the columns to look at change depending
		if toggles, checkboxes are available/selected
	*/
	function _getDataColumns() {
		var result = {
			column: chartConfig.dataColumns.column, 
			column_sup: chartConfig.dataColumns.column_sup, 
			checkboxes: false
		};

		//if there are toggles availables then we need to use the columns specified in the toggle
		if(chartConfig.toggles.length){
			for (var i = 0; i < chartConfig.toggles.length; i++) {
				var currToggle = $($toggles[i]);
				if(currToggle.hasClass("visible")){
					var selected = currToggle.find("input").is(":checked") ? "right" : "left";
					result.column = chartConfig.toggles[i][selected].dataColumns.column;
					result.column_sup = chartConfig.toggles[i][selected].dataColumns.column_sup;

					//special case for gateway completion
					if(Array.isArray(chartConfig.toggles[i][selected].dataColumns.column)){
						var selectedIndex = $form.find("select[name='static']").prop("selectedIndex");
						result.column = chartConfig.toggles[i][selected].dataColumns.column[selectedIndex];
						result.column_sup = chartConfig.toggles[i][selected].dataColumns.column_sup[selectedIndex];
						
						if(selectedIndex === undefined){
							selectedIndex = $form.find("select[name='inst']").prop("selectedIndex");
							result.column = chartConfig.toggles[i][selected].dataColumns.column;
							result.column_sup = chartConfig.toggles[i][selected].dataColumns.column_sup;
						}
					}
				}

			}
		}

		//if there are checkboxes available then we need to use the columns specicied in the checkboxes
		if(chartConfig.checkboxes.length){

			result.checkboxes = [];

			var checkbox, checkboxGroup;

			for (var i = 0; i < chartConfig.checkboxes.length; i++) {
				if(activeDemoCheckboxGroup === undefined){
					checkbox = $($checkboxes[i]).find("input").prop("checked");
				}else{
					/**
						For each demographic chart in the demo section, we have independent checkboxes group
						activeDemoCheckboxGroup tells you which of the groups is last clicked by the user,
						hence "active"
					*/
					checkboxGroup = $($container).find(".checkbox-container[data-checkbox-group='"+activeDemoCheckboxGroup+"']");
					checkbox = $($(checkboxGroup).find(".checkbox")[i]).find("input").prop("checked");
				}

				result.checkboxes[i] = {
					active: checkbox,
					column: chartConfig.checkboxes[i].column,
					column_sup: chartConfig.checkboxes[i].column_sup
				}

			}
		}

		result.column = chartConfig.checkboxes.length ? chartConfig.checkboxes[0].column : result.column;
		result.column_sup = chartConfig.checkboxes.length ? chartConfig.checkboxes[0].column_sup : result.column_sup;

		for (var i = 0; i < chartConfig.filters.length; i++) {
			if(chartConfig.filters[i].column === "column"){
				result.column = $form.find("select[name="+chartConfig.filters[i].column+"]").val();
				result.column_sup = result.column + "_SUP";
			}
		}

		//if datacolumns have attribute multiple = true, we save in an array
		if(chartConfig.dataColumns.multiple && chartConfig.dataColumns.multiple === true){
			result.isMultiple = true;
			result.columns = chartConfig.dataColumns.columns;
		}

		return result;
	}

	function _createDatasets(srcData) {
		
		var dataColumns = _getDataColumns();
		var chartVisualizationType = srcData.chartVisualizationType;
		var data = srcData.data;
		var barIndex = srcData.barIndex;
		var benchmark = srcData.benchmark;
		var column = dataColumns.column;
		var column_sup = dataColumns.column_sup;
		var datasets = [];
		var val;
		//var val = chartConfig.disaggregatedBy.type === "COLUMN" ? data[chartConfig.disaggregatedBy.codes[barIndex]] : data[column];

		if(chartConfig.disaggregatedBy.type === "COLUMN"){
			val = data[chartConfig.disaggregatedBy.codes[barIndex]];
		}else if(chartConfig.disaggregatedBy.type === "static"){
			val = data[column[barIndex]];
		}else{
			val = data[column];
		}

		var verticalSupVal; //vertical suppressed value
		var overage;
		var isEmpty = !val ? true : false;
		var bgColor = isEmpty ? "rgba(224,224,224,100)" : "rgba(45,85,137,100)";
		var hoverColor = isEmpty ? "rgba(224,224,224,0.6)" : "rgba(45,85,137,0.6)";
		var checkbox;
		var checkboxGroup;
		var activeCheckboxes = [];
		var totalWithCheckboxes = 0;
		var pctForDataUnavailableStacks = 0;
		var suppressedCounter = 0;
		var horizontalStackedColors = {
			bg: [
				"rgba(172, 163, 255, 100)",
				"rgba(134, 147, 185, 100)",
				"rgba(45, 85, 137, 100)"
			],
			hv: [
				"rgba(172, 163, 255, 0.6)",
				"rgba(134, 147, 185, 0.6)",
				"rgba(45, 85, 137, 0.6)"
			]
		};
		var gradRateColors = {
			bg: [
				"rgba(89, 72, 255, 0.75)",
				"rgba(147, 147, 147, 0.75)",
				"rgba(172, 163, 255, 0.75)",
				"rgba(45, 85, 137, 0.75)",
				"rgba(146, 158, 194, 0.75)"
				],
			hv: [
				"rgba(89, 72, 255, 0.5)",
				"rgba(147, 147, 147, 0.5)",
				"rgba(172, 163, 255, 0.5)",
				"rgba(45, 85, 137, 0.5)",
				"rgba(146, 158, 194, 0.5)"
			]
		};

		if(chartVisualizationType === "nonDemographic"){

			//DONUTS OR Toggles
			if(chartConfig.measure === "graduation_rate" || chartConfig.measure === "gateway_success" || chartConfig.measure === "credit_accumulation" || chartConfig.measure === "transfer"){
				bgColor = gradRateColors.bg[barIndex];
				hoverColor = gradRateColors.hv[barIndex];
			}

			// calculate stacked dataset
			if (val > benchmark && !isEmpty && benchmark) {
				overage = (val - benchmark).toFixed(1);
				val = benchmark;
			}

			//if of type 6 (design)
			if(dataColumns.checkboxes.length){
				//TODO: Improve on this, not very readable

				for (var i = 0; i < dataColumns.checkboxes.length; i++) {

					if(dataColumns.checkboxes[i].active){
						if(data[chartConfig.checkboxes[i].column_sup] == ""){
							totalWithCheckboxes+= data[chartConfig.checkboxes[i].column];
						}else{
							suppressedCounter++;
						}
					}
				}

				if(suppressedCounter > 0){
					pctForDataUnavailableStacks = (100 - totalWithCheckboxes) / suppressedCounter;
				}

				var horizontalStack = 0;

				for (var i = 0; i < dataColumns.checkboxes.length; i++) {
					var checkbox = dataColumns.checkboxes[i];
					var suppressed = false, dataValuePct = data[checkbox.column];

					if(checkbox.active){
						if(data[checkbox.column_sup] !== ""){
							suppressed = data[checkbox.column_sup];
							dataValuePct = pctForDataUnavailableStacks;
						}

						datasets.push({
							data: [dataValuePct],
							backgroundColor: suppressed ? "rgba(0,0,0,0)" : horizontalStackedColors.bg[i],
							hoverBackgroundColor: suppressed ? "rgba(0,0,0,0)" : horizontalStackedColors.hv[i],
							isPercentage: data.isPercentage || false,
							horizontalStack: horizontalStack,
							labelSup: suppressed,
							checkboxColor: horizontalStackedColors.bg[i]
						});
						horizontalStack++;
					}
				}
			}else{
				datasets.push({
					data: [val],
					backgroundColor: [bgColor],
					hoverBackgroundColor: [hoverColor],
					benchmark: benchmark || 0,
					isPercentage: data.isPercentage || false
				});
			}

			//check if the data is percentage and corresponds to a chart type of donut
			if(data.isPercentage && nonDemographicChartType == "doughnut"){
				//we add the remaining percentage to 
				datasets[0].data.push(100 - val);
				datasets[0].backgroundColor.push("rgba(0,0,0,0)");
				datasets[0].hoverBackgroundColor.push("rgba(0,0,0,0)");
				datasets[0].borderColor = ["rgba(0,0,0,0)", "rgba(0,0,0,0)"];
			}

			if (overage > 0) {
				datasets.push({
					data: [overage],
					backgroundColor: "rgba(255,72,72,100)",
					hoverBackgroundColor: "rgba(255,72,72,0.6)"
				});
			}
			
		}else if(chartVisualizationType === "demographic"){

			$.each(data, function (i, d) {
				overage = 0;

				//val = chartConfig.disaggregatedBy.type === "COLUMN" ? d[chartConfig.disaggregatedBy.codes[barIndex]] : d[column];
				if(chartConfig.disaggregatedBy.type === "COLUMN"){
					val = d[chartConfig.disaggregatedBy.codes[barIndex]];
				}else if(chartConfig.disaggregatedBy.type === "static"){
					val = d[column[barIndex]];
				}else{
					val = d[column];
				}
				
				//verticalSupVal = chartConfig.disaggregatedBy.type === "COLUMN" ? d[chartConfig.disaggregatedBy.codes[barIndex] + "_SUP"] : d[column_sup];
				if(chartConfig.disaggregatedBy.type === "COLUMN"){
					verticalSupVal = d[chartConfig.disaggregatedBy.codes[barIndex] + "_SUP"];
				}else if(chartConfig.disaggregatedBy.type === "static"){
					verticalSupVal = d[column_sup[barIndex]];
				}else{
					verticalSupVal = d[column_sup];
				}


				if(d.dataUnavailableLabel === "DU"){
					verticalSupVal = d.dataUnavailableLabel;
				}
				//val = parseInt(val);

				if (val > benchmark) {
					overage = (val - benchmark).toFixed(1);
					val = benchmark;
				}

				datasets.push({
					label: d.label,
					stack: i,
					backgroundColor: d.bgColor,
					borderWidth: 1,
					data: [val],
					benchmark: benchmark,
					fill: false,
					dataUnavailableLabel: verticalSupVal !== "" ? verticalSupVal : false,
					isPercentage: d.isPercentage || false
				});

				srcData.hoverColors.push(d.hvColor);
				srcData.bgColors.push(d.bgColor);

				//this is important to count the number of DU labels to show on vertical bars
				if(d.label !== "DU"){
					if(srcData.legends.indexOf(d.label) === -1){
						srcData.legends.push(d.label);
					}
				}

				if (overage > 0) {
					datasets.push({
						label: "Excess Time to Degree",
						stack: i,
						backgroundColor: "rgba(255,72,72,100)",
						borderWidth: 0,
						data: [overage]
					});
					srcData.hoverColors.push("rgba(255,72,72,0.6)");
					srcData.bgColors.push("rgba(255,72,72,100)");
				}

			});
		}

		return datasets;
	}


	function _destroyChartInstances() {

		if(chartConfig.type === 6 && currentlyShownChart() == "vertical" && activeDemoCheckboxGroup !== undefined){
			//disaggregated by me dice cual es el array de arrays a borrar
			//si no hay un active checbox, entonces borrar todas
			$.each(instances[activeDemoCheckboxGroup], function(i,c) {
				c.destroy();
			});

			instances[activeDemoCheckboxGroup] = [];

		}else{
			$.each(instances, function(i,c) {
				if(Array.isArray(c)){
					for (var j = 0; j < c.length; j++) {
						c[j].destroy();
					}
				}else{
					c.destroy();
				}
			});

			instances = [];
		}
	}

	function _createRowsForDemoHorizontal(labelsArr, $demoChartContainer) {
		var content = $($demoChartContainer).find(".c-content");
		var demoSections = content.find("[class^='demographic-chart-section-']");
		$.each(demoSections, function (j, section) {

			if(activeDemoCheckboxGroup !== undefined){

				if(j !== activeDemoCheckboxGroup){
					//do nothing
				}else{
					$(section).find(".row.demo-container").html("");
					for (var i = 0; i < labelsArr.length; i++) {
						var row = 
						"<div class='row horizontal-bars'>" +
							"<div class='small-12 medium-3 large-3 columns'>" +
								"<p>" + labelsArr[i].label + "</p>" +
							"</div>" +
							"<div class='small-12 medium-9 large-9 columns horizontal-bar'>" +
								"<canvas class='bar-demo-horizontal-"+(i+1)+"-"+(j+1)+" "+chartConfig.measure+"-bg type-"+chartConfig.type+"'></canvas>" +
								"<div class='type-6-sum-pct'></div>" +
							"</div>" +
						"</div>";
						$(section).find(".row.demo-container").append(row);
					}
				}

			}else{
				$(section).find(".row.demo-container").html("");
				for (var i = 0; i < labelsArr.length; i++) {
					var row = 
					"<div class='row horizontal-bars'>" +
						"<div class='small-12 medium-3 large-3 columns'>" +
							"<p>" + labelsArr[i].label + "</p>" +
						"</div>" +
						"<div class='small-12 medium-9 large-9 columns horizontal-bar'>" +
							"<canvas class='bar-demo-horizontal-"+(i+1)+"-"+(j+1)+" "+chartConfig.measure+"-bg type-"+chartConfig.type+"'></canvas>" +
							"<div class='type-6-sum-pct'></div>" +
						"</div>" +
					"</div>";
					$(section).find(".row.demo-container").append(row);
				}
			}


		});

		$demographicBars = demographicChartType == "bar" ? $($container).find("[class^='bar-vertical-']") : $($container).find("[class^='bar-demo-horizontal-']");
		$($demographicBars).hover(
			function () {
				hoveredVerticalBar = $(this);
			},
			function () {
				hoveredVerticalBar = null;
				$demographicTooltip.css("visibility", "hidden");
			}
		);
	}

	/** creates query object for ajax*/
	function _createQueryObj() {
		var query = {
			action: "chart_results",
			measure: chartConfig.measure,
			type: chartConfig.type,
			order_by: chartConfig.disaggregatedBy.type
		};

		//for each filter, it adds the value of the dropdown to the query
		for (var i = 0; i < chartConfig.filters.length; i++) {
			query[chartConfig.filters[i].column] = $form.find("select[name="+chartConfig.filters[i].column+"]").val()
		}

		//for each toggles, it adds the value of the toggle to the query, if its visible
		for (var i = 0; i < chartConfig.toggles.length; i++) {
			var currToggle = $($toggles[i]);
			if(currToggle.hasClass("visible")){
				var selected = currToggle.find("input").is(":checked") ? "right" : "left";
				query.toggle = chartConfig.toggles[i][selected].dataColumns;
			}

		}

		return query;
	}

	/**
		Creates the Chart instance for each horizontal canvas
		and creates the dataset array. If the data value exceeds the
		benchmark value, it splits the original value into two datasets
		objects in the datasets array, so the graph can create the stacked
		bars. The benchmark parameter inicates at what point the horizontal
		line has to be drawn.
	*/

	function _drawHorizontalBar(barCanvas, data, benchmark, barIndex) {
		var overage = 0;
		var dataColumns;
		var column;
		var datasets;
		var column_sup;
		var maxTick = chartConfig.ticks.maxTick;
		
		datasets = _createDatasets({
			chartVisualizationType: "nonDemographic",
			data: data, 
			benchmark: benchmark, 
			barIndex: barIndex
		});

		// draw the bar
	  	var chart = new Chart(barCanvas, {
			type: nonDemographicChartType,
			data: {
				labels: [data.YR_LABEL],
				datasets: datasets,
				borderWidth: 3,
				chartId: chartId,
				type:chartConfig.type
			},
			options: {
				cutoutPercentage: 25,
				maintainAspectRatio: false,
				lineAtIndex: benchmark,
				lineDrawn: false,
				responsive: true,
				tooltips: {
					enabled: false,
					callbacks: {
						label: function(tooltipItems, data) {
							if(nonDemographicChartType === "doughnut"){
								return data.labels;
							};
							
							return tooltipItems.yLabel;
						}
					},
					custom: function(tooltip) {
						/**
							If the tooltip was previously hidden (or if it's already visible we want to keep it visible) and the variable 
							hoveredHorizontalBar is not null, it means that a bar is being hovered. So we show the tooltip
						*/
						var $tooltip, hoveredBar;
						if(chartConfig.type === 6 && currentlyShownChart() === "vertical"){
							$tooltip = $demographicTooltip;
							hoveredBar = hoveredVerticalBar;
						}else{
							$tooltip = $nonDemographicTooltip;
							hoveredBar = hoveredHorizontalBar;
						}

						if($tooltip.css("visibility") === "visible" || $tooltip.css("visibility") === "hidden" && hoveredBar !== null){
							$tooltip.css("visibility", "visible");
						}

						//otherwise we hide it
						if($tooltip.css("visibility") === "visible" && hoveredBar === null){
							$tooltip.css("visibility", "hidden");	
						}

						//If we are not hovering on a bar we do nothing (not really sure if this is actually necessary)
						if(hoveredBar === null) return;

						// Set Text
						if (tooltip.body) {
							var innerHtml = [ (tooltip.body[0].lines || []).join("\n") ];
							$tooltip.html(innerHtml.join("\n").replace(/,/g, ", "));
						}
						// Find Y Location on page
						var top = tooltip.y + tooltip.caretHeight + tooltip.caretPadding;

						//got to figure out how to get the position of the canvas
						var position = $(hoveredBar)[0].getBoundingClientRect();

						var verticalPos, horizontalPos;
						if(nonDemographicChartType === "doughnut"){
							verticalPos = $(this._chart.canvas).offset().top + ($(this._chart.canvas).height() / 2) - 36;
							horizontalPos = position.left + ($(this._chart.canvas).width() - $($tooltip).width()) / 2;
						}else{
							verticalPos = position.top + (jQuery(window).scrollTop() - 16);
							horizontalPos = position.left + 10;
						}

						// Display, position, and set styles for font
						$tooltip.css({ 
							opacity: 1,
							border:"3px solid #282828",
							backgroundColor: "rgba(255,255,255,0.8)",
							position:"absolute",
							width: "auto",
							left: horizontalPos + "px",
							top: verticalPos + "px",
							fontSize: tooltip.fontSize,
							fontStyle: "bold",
							padding: "3px 5px",
							fontWeight: 700
						});
		        	}
				},
				hover :{
					animationDuration:0
				},
				scales: {
					xAxes: [{
							display:false,
							ticks: {
								beginAtZero: true,
							},
							scaleLabel:{
								display: true
							},
							gridLines: {
								display: false
							}, 
							ticks: {
								display: true,
								min: 0,
								max: maxTick
							},
							stacked: true
						}],
					yAxes: [{
						barThickness: 36.5,
						gridLines: {
							display: false,
							zeroLineWidth: 0,
							drawBorder: false
						},
						ticks: {
							display: false
						},
						stacked: true
					}]
				},
				legend:{
					display:false
				},
				pointLabelFontFamily : "'korolev-condensed', 'sans-serif'",
				scaleFontFamily : "'korolev-condensed', 'sans-serif'",
			}
		});

		return chart;
	}

	/** 
		Adds empty lines to vertical charts depending on how many vertical bars are there
		in a chart instance
	*/
	function _addLineBarsToVerticalBars(canvas, numOfBars) {
		var c = jQuery(canvas);

		$(c)[0].className = $(c)[0].className.replace(/\bvertical-bars-perc_test-.*?\b/g, '');

		jQuery(c).addClass("vertical-bars-perc_test-"+numOfBars);
	}

	function _drawVerticalBar(barCanvas, data, benchmark, barIndex, labelsLength){
		var datasets;
		var maxTick = chartConfig.ticks.maxTick;
		var column = chartConfig.dataColumns.column;
		var column_sup = chartConfig.dataColumns.column_sup;
		var legends = [];
		var hoverColors = [];
		var bgColors = [];


		//console.log("labelsLength",labelsLength);

		datasets = _createDatasets({
			chartVisualizationType: "demographic",
			data: data, 
			benchmark: benchmark, 
			barIndex: barIndex,
			//we need to fill the colors and legends of these arrays, so we pass the reference
			bgColors: bgColors,
			hoverColors: hoverColors,
			legends: legends
		});

		var labelText = "";
		for (var i = 0; i < data.length; i++) {
			if(data[i].YR_LABEL){
				labelText = data[i].YR_LABEL;
			}
		}

		var chart = new Chart(barCanvas, {
		type: demographicChartType,
		data: {
			labels: [labelText],
			datasets: datasets,
			line1: benchmark,
			line2: benchmark,
			line3: benchmark,
			line4: benchmark,
			cca_meta: {
				hoverColors: hoverColors,
				bgColors: bgColors,
				legends: legends
			},
			chartId: chartId
		},
		options: {
			maintainAspectRatio: false,
			responsive: true,
			elements: {
				point: {
					radius: 0,
					hitRadius: 0,
					hoverRadius: 0,
				}
			},
			legendCallback: function (chart) {
				// we actually just want to normalize the legend here
				chart.data.datasets.forEach(function(dataset, i) {
					verticalLegend.push({
						label: dataset.label,
						color: dataset.backgroundColor
					});
				});
		  	},
			tooltips: {
				enabled: false,
				callbacks: {
					label: function(tooltipItems, data) {
						currentlyHoveredItemIndex = tooltipItems.datasetIndex;
						return tooltipItems.xLabel +"<br />"+ this._chart.legend.legendItems[tooltipItems.datasetIndex].text;
					}
				},
				custom: function(tooltip) {
					/**
						If the tooltip was previously hidden (or if it's already visible we want to keep it visible) and the variable 
						hoveredHorizontalBar is not null, it means that a bar is being hovered. So we show the tooltip
					*/

					if($demographicTooltip.css("visibility") === "hidden" || $demographicTooltip.css("visibility") === "visible" && hoveredVerticalBar !== null){
						$demographicTooltip.css("visibility", "visible");
					}

					if($demographicTooltip.css("visibility") === "visible" && hoveredVerticalBar === null){
						$demographicTooltip.css("visibility", "hidden");
					}

					if(hoveredVerticalBar === null) return;

					// Set Text
					if (tooltip.body) {
						var innerHtml = [ (tooltip.body[0].lines || []).join("\n") ];
						$demographicTooltip.html(innerHtml.join("\n").replace(/,/g, ", "));
					}
					// Find Y Location on page
					var top = tooltip.y + tooltip.caretHeight + tooltip.caretPadding;

					//got to figure out how to get the position of the canvas
					var position = $(hoveredVerticalBar)[0].getBoundingClientRect();
					var leftPos = position.left + ($(this._chart.canvas).width() - $($demographicTooltip).width()) / 2.2;

					// Display, position, and set styles for font
					$demographicTooltip.css({ 
						opacity: 1,
						border:"3px solid #282828",
						backgroundColor: "rgba(255,255,255,0.8)",
						position:"absolute",
						width: "auto",
						left: leftPos + "px",
						top: position.top + jQuery(window).scrollTop() + "px",
						padding: "3px 5px",
						fontWeight: 700
					});
				}
		  	},
			hover :{
				animationDuration:0
			},
			scales: {
				xAxes: [{
					barThickness: labelsLength > 5 ? 29 : 33,
					ticks: {
						beginAtZero:true,
						display: false,
					},
					scaleLabel:{
						display:false
					},
					gridLines: {
						display: false
					}, 
					stacked: true
				}],
				yAxes: [{
					display: false,
					gridLines: {
						display: true,
						tickMarkLength: 15,
						lineWidth: 3,
						stepSize: 4,
						drawBorder: true,
						drawOnChartArea: false,
						color: "#282828",
					},
					ticks: {
						display: true,
						min: 0,
						max: maxTick,
			  		},
					stacked: true
				}]
		  },
		  title: {
			display: false,
			position: "bottom",
			text: "1- 2-YEAR CERTIFICATE",
			fontFamily: "'korolev-condensed', 'sans-serif'",
			fontSize: 18
		  },
		  legend:{
			display:false
		  },
		}
	  });

	  return chart;
	}

	function _updateVerticalCharts() {

		if (hasBeenInitialized == false) return;

		if(chartConfig.type === 6) return _updateDemoHorizontalCharts();

		//Columns used to display the data
		var column;
		var column_suppress;

		var measurements = {
			desktop: {
				height: 450,
				width: 240
			},
			tablet: {
				height: 450,
				width: 240
			},
			mobile:{
				height: 340,
				width: 272
			}
		};

		var query = _createQueryObj();
		//console.log("query", query);

		//this is a workaround
		var demoSelected = query.demo;
		//aux var
		var settings = query.settings;

		if(chartConfig.type === 7){
			$demographicChart.find(".pictograph-slider-container").css("visibility", "hidden");
		}

		$demographicChart.find(".nav-arrow.prev-arrow").trigger("click");
		$($nonDemographicChart).fadeOut("fast", function () {
			$($nonDemographicChart).hide();
			$($demographicChart).fadeIn("fast", function () {
				$($demographicChart).show();
				if(chartConfig.type === 7){
					$demographicChart.find(".nav-arrow.prev-arrow").trigger("click");
					$demographicChart.find(".pictograph-slider-container").slick("refresh");
					$demographicChart.find(".pictograph-slider-container").css("visibility", "visible");
				}
			});
		});

		$.get(window.homeUrl + "/wp-admin/admin-ajax.php", query, function(resp) {
			var results = JSON.parse(resp);
			//console.log("results", results);
			var toDraw = chartConfig.disaggregatedBy.codes;
			var disByType = chartConfig.disaggregatedBy.type;
			var drawnBars = [];
			
			//if there are toggles availables then we need to use the columns specified in the toggle
			if(query.toggle){
				column = query.toggle.column;
				column_suppress = query.toggle.column_sup;
			}else{
				column = chartConfig.dataColumns.column;
				column_suppress = chartConfig.dataColumns.column_sup;
			}

			//We initialize a noData variable in case there are unavailable demographic data 
			var noData = {
				bgColor: "#fff",
				hvColor: "#fff",
				label: "DU",
				dataUnavailableLabel: "DU"
			};

			//We add value 0 to the data column of the request 
			noData[column] = 0;

			var data = {};


			for (var i = 0; i < toDraw.length; i++) {
				data[toDraw[i]] = [];
			}

			//HACK! how to deal when there's no labels data whatsoever, we still need to show emtpy data
			//and for that we need to have all the labels depending on the demografic value selected
			if(results.labels.length === 0){
				console.log("No label data!"); 
				if(demoSelected === "Race/Ethnicity"){
					results.labels = JSON.parse(JSON.stringify([{"label":"Asian","code":"RAS","bgColor":"rgba(172,163,255,100)","hvColor":"rgba(172,163,255,0.6)"},{"label":"Hispanic","code":"RHS","bgColor":"rgba(45,85,137,100)","hvColor":"rgba(45,85,137,0.6)"},{"label":"Pacific Islander","code":"RPI","bgColor":"rgba(146,158,194,100)","hvColor":"rgba(146,158,194,0.6)"},{"label":"White","code":"RWH","bgColor":"rgba(189,189,189,100)","hvColor":"rgba(189,189,189,0.6)"}]));
				}else if(demoSelected === "Remedial Status"){
					results.labels = JSON.parse(JSON.stringify([{"label":"Took Remedial (any time)","code":"RC2","bgColor":"rgba(89,72,255,100)","hvColor":"rgba(89,72,255,0.6)"},{"label":"Did Not Take Remedial (any time)","code":"RCN","bgColor":"rgba(147,147,147,100)","hvColor":"rgba(147,147,147,0.6)"}]));
				}else if(demoSelected === "Pell Status"){
					results.labels = JSON.parse(JSON.stringify([{"label":"All Students","code":"TOT","bgColor":"rgba(89,72,255,100)","hvColor":null},{"label":"Received Pell (any time)","code":"PG2","bgColor":"rgba(147,147,147,100)","hvColor":"rgba(89,72,255,0.6)"}]));
				}else if(demoSelected === "Gender"){
					results.labels = JSON.parse(JSON.stringify([{"label":"Female","code":"RGF","bgColor":"rgba(89,72,255,100)","hvColor":"rgba(89,72,255,0.6)"},{"label":"Male","code":"RGM","bgColor":"rgba(147,147,147,100)","hvColor":"rgba(147,147,147,0.6)"}]));	
				}else if(demoSelected === "Age"){
					results.labels = JSON.parse(JSON.stringify([{"label":"Directly from High School (17-19)","code":"AHS","bgColor":"rgba(89,72,255,100)","hvColor":"rgba(89,72,255,0.6)"},{"label":"Age 25 and Over","code":"AAD","bgColor":"rgba(147,147,147,100)","hvColor":"rgba(147,147,147,0.6)"},{"label":"Other (20-24)","code":"AOT","bgColor":"rgba(172,163,255,100)","hvColor":"rgba(172,163,255,0.6)"}]));
				}
			}

			// fill with empty data
			$.each(results.labels, function(i, lbl) {
				for (var i = 0; i < toDraw.length; i++) {
					data[toDraw[i]].push(noData);
				}
			});

			//console.log("results.labels.length", results.labels.length);

			/**
				Wecreate the data array where we store all the data, depending
				on the disaggregation codes
			*/
			if(disByType === "COLUMN"){
				$.each(toDraw, function(i, td) {
					$.each(results.labels, function(j, lbl) {
						var index = results.data.findIndex(function (d) {
							return d.DEMO === lbl.code;
						});

						if(index > -1){						
							results.data[index].bgColor = lbl.bgColor;
							results.data[index].hvColor = lbl.hvColor;
							data[td][j] = results.data[index];

							if(drawnBars.indexOf(td) === -1) drawnBars.push(td);
						}
					});
				});
			}else if(disByType === "static"){
				$.each(toDraw, function(i, td) {
					$.each(results.labels, function(j, lbl) {
						var index = results.data.findIndex(function (d) {
							return d.DEMO === lbl.code;
						});

						if(index > -1){
							results.data[index].bgColor = lbl.bgColor;
							results.data[index].hvColor = lbl.hvColor;
							data[td][j] = results.data[index];

							if(drawnBars.indexOf(td) === -1) drawnBars.push(td);
						}
					});
				});	
			}else if(disByType == "none"){
				_updateVerticalPictographic(results);
			}else{
				$.each(results.data, function(i, d) {
					$.each(results.labels, function(j, lbl) {
						if (d.DEMO == lbl.code) {

							d.bgColor = lbl.bgColor;
							d.hvColor = lbl.hvColor;
							data[d[disByType]][j] = d;

							drawnBars.push(d[disByType]);
						}
					});
				});
			}

			/**
				Once we have the data prepared, we need to draw the graphs
			*/
			if(chartConfig.type === 7) return;
			_plotVerticalData(data, results.labels);
			
			var $html = $("<ul class='menu'></ul>");
			$.each(results.labels, function(i, lbl) {
				$html.append("<li><span class='box' style='background-color: " + lbl.bgColor + "'></span>" + lbl.label + "</li>");
			});

			$($demographicChart).find(".legend-vertical.first.full-width").html($html);
			
			//mobile
			$($demographicChart).find(".row.legend-vertical.second.mobile-key").html($($demographicChart).find(".legend-vertical.first.full-width").html()).append("<hr />");
		});
	}
	

	/**
	 * @argument ajaxData
	 * @argument dataColumns
	 * 
	 * @description It parses the data gathered in the ajax and plots the data accordingly
	 */
	function _updateHorizontalPictographic(ajaxData, dataColumns){
	
		var selectedIndex = $form.find("select[name='static']").prop("selectedIndex");
		var slidersContainer = $container.find(".horizontal-charts .pictograph-slider-container, .vertical-charts .pictograph-slider-container");
		
		if(ajaxData.length){
			$.each(ajaxData, function (j, data) {
				$.each(dataColumns.columns, function (i, col) {
					if(ajaxData.length){
						if(selectedIndex === i){
							$.each(col.slides, function (k, slide) { 
								_plotHorizontalPictographicData(k, col.slides, data, col.forLabel);
							});
						}
					}else{
						//show 'no availabnle data'
					}
				});
			});

			//reset animation flags
			pictoHasBeenAnimated_demo = false;
			pictoHasBeenAnimated_nondemo = false;
			//set event listenersa
			slidersContainer.off("afterChange", _onSlideChange);
			slidersContainer.on("afterChange", _onSlideChange);
		}
	}

	/**
	 * Parses the data of ajax call and calls _plotVerticalPictographic
	 * 
	 * @param {Object} ajaxData ajax taken from the ajax call
	 * @param {Object} dataColumns 
	 */

	function _updateVerticalPictographic(ajaxData) {
		var labels = ajaxData.labels;
		var data = ajaxData.data;
		var selectedIndex = $form.find("select[name='static']").prop("selectedIndex");
		var columns = _getDataColumns().columns[selectedIndex];

		pictoHasBeenAnimated_demo = false;
		pictoHasBeenAnimated_nondemo = false;

		$demoPictoContainer.find(".pictograph-container").html("");

		$.each(labels, function (i, lbl) { 
			if(ajaxData.data.length){
				_plotVerticalPictographicData(data[i], columns, lbl.label, i, columns.forLabel);
			}
		});

	}

	/**
	 * 
	 * @param {any} data 
	 * @param {any} columns 
	 * @param {any} label 
	 * @param {any} index 
	 * @param {object} remLabel the name of the remediation selected
	 */
	function _plotVerticalPictographicData(data, columns, label, index, remLabel) {
		var template;
		//var value1 = data[columns.slides[0].column_sup] !== "" ? 100 : Math.floor(data[columns.slides[0].column]);
		//var value2 = data[columns.slides[1].column_sup] !== "" ? 100 : Math.floor(data[columns.slides[1].column]);
		var value1 = data[columns.slides[0].column_sup] !== "" ? 100 : Math.floor(data[columns.slides[0].column] * 100);
		var value2 = data[columns.slides[1].column_sup] !== "" ? 100 : (value1 - Math.floor(data[columns.slides[1].column] * data[columns.slides[0].column] * 100)); 

		$.each(columns.slides, function (i, slide) {
			template = "";
			template += "<div class='small-12 medium-12 large-2 columns picto-column "+(data[columns.slides[i].column_sup] !== "" ? "row-disabled" : "")+"'>";
			template += "<div class='person-picto-container'>";
			var templatePersonValue = i === 1 && data[columns.slides[i].column_sup] !== "" ? value2 : value1; 
			for(var j = 0; j < templatePersonValue; j++){
				//console.log("asd", i);
				template += "<div class='person-picto person-svg "+(data[columns.slides[i].column_sup] !== "" ? "disabled" : "")+" "+(i === 0 ? data[columns.slides[i].column_sup] !== "" ? "" : "picto-hidden" : "")+"'></div>";
			}
			template += "</div>";
			template += "<h3>"+label+"</h3>";
			template += "<div class='title-container'>";
			if(data[columns.slides[i].column_sup] !== ""){
				template += "<h2 class='pictograph-slide-title disabled'>"+_convertHorizontalLabel(data[columns.slides[i].column_sup])+"</h2>";
			}else{
				template += "<h2 class='pictograph-slide-title'>FOR EVERY 100 STUDENTS STARTING COLLEGE, <span class='alt-text'><span data-value='val1'>"+value1+"</span> ARE ENROLLED IN "+remLabel+" REMEDIATION.</span></h2>";
				if(i == 1){
					template += "<h2 class='pictograph-slide-title red' style='display: none;'>OF THOSE STUDENTS, <span data-value='val2'>"+value2+"</span> fail to complete the associated gateway course.</h2>";
				}
			}
			template += "</div></div>";

			$($demographicChart.find(".slide-"+i+" .pictograph-container")).append($(template));
			
			if(i === 0){
				var pictoColumns = $demographicChart.find(".slide-"+i+" .pictograph-container .picto-column");
				$.each(pictoColumns, function (j, col) {
					_animatePictographicChartInitial($(col).find(".person-picto-container .person-picto"), value1, true);
				});
			}

		});
	}

	function _updateHorizontalCharts(){

		if (hasBeenInitialized == false) return;

		var query = _createQueryObj();

		//hide/show the ticks 
		$($nonDemographicBars).each(function (i) {
			if(currMeasure === "mobile"){
				$(this).find(".mobile-horizontal-bar").show();
			}else{
				$(this).find(".mobile-horizontal-bar").hide();
			}
		});

		$nonDemographicChart.find(".nav-arrow.prev-arrow").trigger("click");
		
		if(chartConfig.type === 7){
			$nonDemographicChart.find(".pictograph-slider-container").css("visibility", "hidden");
		}
		
		$($demographicChart).fadeOut("fast", function () {
			$($demographicChart).hide();
			$($nonDemographicChart).fadeIn("fast", function () {
				$($nonDemographicChart).show();
				if(chartConfig.type === 7){
					$nonDemographicChart.find(".pictograph-slider-container").slick("refresh");
					$nonDemographicChart.find(".pictograph-slider-container").css("visibility", "visible");
				}
			});
		});


		//make the ajax request for the data
		$.get(window.homeUrl + "/wp-admin/admin-ajax.php", query, function(resp) {
			var results = JSON.parse(resp);
			//console.log("resp", resp);
			//console.log("query", query);
			var toDraw = chartConfig.disaggregatedBy.codes;
			var disByType = chartConfig.disaggregatedBy.type; 
			var drawnBars = [];
			var dataColumns = _getDataColumns();
			var column = dataColumns.column;
			var column_suppress = dataColumns.column_sup;

			if(disByType == "none"){
				_updateHorizontalPictographic(results, dataColumns);
			}

			if(disByType === "COLUMN"){
				//aca debo buclear de forma diferente
				$.each(toDraw, function(i, td) {
					if(results.length){					
						if (results[0][td + "_SUP"] == "") {
							var chart = _plotHorizontalData(results[0], toDraw.indexOf(td)); 
							_saveChartInstances(chart);
						}else{
							//console.log("results[0][td + _SUP]", results[0][td + "_SUP"]);
							_plotHorizontalEmpty(results[0], results[0][td + "_SUP"], toDraw.indexOf(td), disByType);
						}
						drawnBars.push(td);
					}
				});
			}else if(disByType === "static"){
				$.each(toDraw, function(i, td) {
					if(results.length){
						if (results[0][column_suppress[toDraw.indexOf(td)]] == "") {
							var chart = _plotHorizontalData(results[0], toDraw.indexOf(td)); 
							_saveChartInstances(chart);
						}else{
							//tambien debo
							_plotHorizontalEmpty(results[0][toDraw.indexOf(td)], results[0][column_suppress[toDraw.indexOf(td)]], toDraw.indexOf(td), disByType);
						}
						drawnBars.push(td);
					}
				});

			}else{
				//when disByType === INST
				$.each(results, function(i, res) {
					if (res[column_suppress] == "") {
						var chart = _plotHorizontalData(res, toDraw.indexOf(res[disByType]));
						_saveChartInstances(chart);
					} else {
						if(res[column_suppress] == "DU"){
							res.label_short = "DU";
							res.label = "Data Unavailable";
						}
						_plotHorizontalEmpty(res, res[column_suppress], toDraw.indexOf(res[disByType]), disByType);
					}

					drawnBars.push(res[disByType]);    
				});
			}

			if(disByType === "COLUMN"){
				$.each(toDraw, function(i, v) {
					if (drawnBars.indexOf(v) < 0) {
						var emptyData = {
							label: "Data Unavailable",
							label_short: "DU"
						};
						emptyData[toDraw[i]] = 0;
						_plotHorizontalEmpty(emptyData,emptyData.label,i);
					}
				});
			}else{
				$.each(toDraw, function(i, v) {
					if (drawnBars.indexOf(v) < 0) {
						var emptyData = {
							INST: v,
							label: "Data Unavailable",
							label_short: "DU"
						};
						emptyData[column] = 0;
						_plotHorizontalEmpty(emptyData,false,i);
					}
				});
			}
		});
	}
	
	/** 
	 * Function that takes the data and plots the graphic
	 * 
	 * @param slide {Number} the slide number that the data represents
	 * @param columns {String} the data columns
	 * @param data {Object} the actual data to use
	*/
	function _plotHorizontalPictographicData(slide, columns, data, remLabel){
		var template;
		var value1 = data[columns[0].column_sup] !== "" ? 100 : Math.floor(data[columns[0].column] * 100);
		//console.log("value1", value1);

		var value2 = data[columns[1].column_sup] !== "" ? 100 : (value1 - Math.floor(data[columns[1].column] * data[columns[0].column] * 100)); 
		var isSuppressed = data[columns[slide].column_sup] !== "" ? true : false;
		var suppressedLabel = _convertHorizontalLabel(data[columns[slide].column_sup]);

		//console.log("slide", slide);


		template = "<div class='title-container'>";
		template += "<h2 class='pictograph-slide-title "+(isSuppressed ? "disabled" : "")+"'>";
		if(isSuppressed){
			template += suppressedLabel;
		}else{
			template += "FOR EVERY 100 STUDENTS STARTING COLLEGE, <span class='alt-text'><span data-value='val1'>"+value1+"</span> ARE ENROLLED IN "+remLabel+" REMEDIATION.</span>";			
		}
		template += "</h2>";
		if(slide == 1 && !isSuppressed){
			template += "<h2 class='pictograph-slide-title red' style='display: none;'>OF THOSE STUDENTS, <span data-value='val2'>"+value2+"</span> fail to complete the associated gateway course.</h2>";
		}
		template += "</div>";
		template += "<div class='pictograph-container'>";
		for (var i = 0; i < value1; i++) {
			template += "<div class='person-picto person-svg "+(isSuppressed ? "disabled" : "")+"  "+(slide == 0 ? isSuppressed ? "" : "picto-hidden" : "")+"'></div>";
		}
		template += "</div>";

		$nonDemographicChart.find(".slide-"+slide).html("").append(template);

		if(slide === 0){
			var personIcons = $nonDemographicChart.find(".slide-"+slide+" .pictograph-container .person-picto");
			_animatePictographicChartInitial(personIcons, value1, false);
		}
	}

	/**
	 * Draws the pictograph with the correct data
	 * 
	 * @param {Number} slide 
	 * @param {Number} value 
	 */

	function _drawNonDemoPictographicChart(slide, value) {
			
		$nonDemoPictoContainer.find(".nav-arrow.prev-arrow").trigger("click");
		
		$nonDemographicChart.find("span[data-value='val"+(slide+1)+"']").each(function () {
			$(this).html(value);
		});

		if(slide == 0){
			$nonDemoPictoContainer.find(".pictograph-container").html("");
			for (var i = 0; i < value; i++) {
				$nonDemoPictoContainer.find(".pictograph-container").append("<div class='person-picto person-svg'></div>");
			}
		}

	}

	/**
	 * 
	 * 
	 * @param {Number} slick 
	 * @param {Number} currentSlide 
	 */
	function _onSlideChange(slick, currentSlide) {

		var currSlide = currentSlide.currentSlide; //index of current slide	
		var demoType = $(this).parent().hasClass("horizontal-charts") ? "nonDemo" : "demo";
		var demoContainer = demoType === "nonDemo" ? $nonDemoPictoContainer : $demoPictoContainer;
		var pictoHasBeenAnimated = demoType === "nonDemo" ? pictoHasBeenAnimated_nondemo : pictoHasBeenAnimated_demo;


		if(currSlide === 0){
			$(this).find("button.nav-arrow.prev-arrow").addClass("first");
		}else{
			$(this).find("button.nav-arrow.prev-arrow").removeClass("first");
		}

		if(currSlide === 1){
			setTimeout(function () {
				if(!pictoHasBeenAnimated){
					$(demoContainer).find(".slide-1 .title-container .pictograph-slide-title.red").fadeIn("fast");
					var demoClass = demoType === "nonDemo" ? "person-picto" : "person-picto-container .person-picto";

					if(demoType === "nonDemo"){
						_animatePictographicChart($(demoContainer).find(".slide-1 .pictograph-container ."+demoClass), parseInt($(demoContainer).find("[data-value='val2']").html()), false);
					}else{
						var containers = $(demoContainer).find(".slide-1 .pictograph-container .picto-column");

						$.each(containers, function (i, container) { 
							var val2 = parseInt($(container).find("[data-value='val2']").html());
							_animatePictographicChart($(container).find(".person-picto"), val2, true);
						});

					}

					if(demoType === "nonDemo"){
						pictoHasBeenAnimated_nondemo = true;
					}else{
						pictoHasBeenAnimated_demo = true;
					}
				}
			},100);

			$(this).find("button.nav-arrow.next-arrow").addClass("last");
		}else{
			$(this).find("button.nav-arrow.next-arrow").removeClass("last");
		}
	}

	/**
	Special case for 6, needs refactoring because of duplicated code 
	*/
	function _updateDemoHorizontalCharts(){

		var query = _createQueryObj();

		//make the ajax request for the data
		$.get(window.homeUrl + "/wp-admin/admin-ajax.php", query, function(resp) {
			//console.log("resp", resp);
			var results = JSON.parse(resp);
			var labels = results.labels;
			var toDraw;
			var drawnBars = [];
			var data = results.data;
			var disByType = chartConfig.disaggregatedBy.type;
			var demoGroup;
			var count;

			_createRowsForDemoHorizontal(labels, $demographicChart);

			toDraw = [];
			$.each(chartConfig.disaggregatedBy.codes, function (j, dis) {
				toDraw[j] = [];	
				drawnBars[j] = [];
				$.each(labels, function (i,l) {
					toDraw[j][i] = l.code;
				});
			});

			$($nonDemographicChart).fadeOut("fast", function () {
				$($nonDemographicChart).hide();
				$($demographicChart).fadeIn("fast", function () {
					$($demographicChart).show();
				});
			});
			var column;
			var column_suppress;
			
			//if there are toggles availables then we need to use the columns specified in the toggle
			if(query.toggle){
				column = query.toggle.column;
				column_suppress = query.toggle.column_sup;
			}else{
				column = chartConfig.dataColumns.column;
				column_suppress = chartConfig.dataColumns.column_sup;	
			}

			$.each(chartConfig.disaggregatedBy.codes, function (j, disCode) {
				demoGroup = j;
				count = (labels.length) * j;

				$.each(data, function(i, d) {
					if(activeDemoCheckboxGroup !== undefined && activeDemoCheckboxGroup !== demoGroup){

					}else{
						if(d[disByType] !== disCode){
							//do nothing
						}else{
							var chart = _plotHorizontalData(d, count);
							_saveChartInstances(chart, demoGroup); //here it's different
							drawnBars[demoGroup].push(d.DEMO);
							count++;
						}
					}
				});
			});
		});
	}

	function _plotHorizontalData(data, barIndex) {
		var benchmarks = chartConfig.benchmarks;
		var bars = $nonDemographicBars;

		if(chartConfig.type === 6 && currentlyShownChart() === "vertical"){
			bars = $demographicBars;
		}

		$(bars[barIndex]).parent().find("span").remove();
		$(bars[barIndex]).show();

		return _drawHorizontalBar(bars[barIndex], data, benchmarks[barIndex], barIndex);
	}

	function _plotVerticalData(data, labels) {
		
		var chart;
		var benchmarks = chartConfig.benchmarks;
		var keys = Object.keys(data);

		$.each(keys, function (i, key) {
			//Add the empty bars, the number depends on how many labels
			if(chartConfig.measure == "graduation_rate" || 
				chartConfig.measure == "credit_accumulation" || 
				chartConfig.measure == "gateway_completion" || 
				chartConfig.measure == "transfer" || 
				chartConfig.measure == "gateway_success"){
				_addLineBarsToVerticalBars($demographicBars[i], labels.length);
			}
			if(data[key].length){
				chart = _drawVerticalBar($demographicBars[i], data[key], benchmarks[i], i, labels.length);
				_saveChartInstances(chart);
			}
		})

		return chart;
	}

	function _plotHorizontalEmpty(data, label, index, disByType) {

		var canvas;
		var dataLabel = label === false ? data.label_short : label;
		var bars = $nonDemographicBars;
		if(chartConfig.type === 6 && currentlyShownChart() === "vertical"){ //special case
			bars = $demographicBars;
		}

		if(index > -1){
			canvas = bars[index];
		}

		if ($(canvas).length) {
			var container = $(canvas).parent();

			container.find("span").remove();			
			
			if(nonDemographicChartType === "horizontalBar"){
				container.prepend("<span class='box text'>"+_convertHorizontalLabel(label)+"</span>");

				if(chartConfig.type === 6){
					jQuery(canvas).parent().find(".type-6-sum-pct").html("");
				}

			}else if(nonDemographicChartType === "doughnut"){
				if(disByType === "COLUMN"){
					dataLabel = label;
				}else{
					dataLabel = data.label_short;
				}
				container.prepend("<span class='box text donut-empty-horizontal'>"+dataLabel+"</span>");
			}
		}
	}

	function _convertHorizontalLabel(label) {
		if (label == "DU") {
			return "Data Unavailable";
		}

		if (label == "DS") {
			return "Data Suppressed";
		}

		if (label == "NA") {
			return "Not Applicable";
		}

		if (label == "NR") {
			return "Not Reported";
		}

		return "Data Unavailable";
	}

	function _convertHorizontalLabelSHORT(label) {
		if (label == "Data Unavailable") {
			return "DU";
		}

		if (label == "Data Suppressed") {
			return "DS";
		}

		if (label == "Not Applicable") {
			return "NA";
		}

		if (label == "Not Reported") {
			return "NR";
		}

		return "DU";
	}

	/**
	 * Function That gets call on window resize to reorder and show the colored icons 
	 * how they should on responsive
	 * 
	 * @param {any} personIcons 
	 */
	function _reColorPictographsVertical(personIcons) {
		var maxValue = 0;
		$.each(personIcons, function (i, p) { 
			if($(p).hasClass("red")){
				$(p).removeClass("red");
				maxValue++;
			}
		});

		_animatePictographicChart(personIcons, maxValue, true);
	}


	function _animatePictographicChart(personIcons, maxValue, isDemo) {
		var i = 0;
		//animate person
		var requestID;

		if(isDemo){
			var howManyFitInRow = Math.floor($($(personIcons[0]).parent()).innerWidth() / (18 + parseFloat($(personIcons[0]).css("margin-right"))));
			var HowManyRows = Math.ceil(personIcons.length / howManyFitInRow);
			var aux2 = 0;
			var pintados = 0;
			var filaPointer = HowManyRows;
			var limit = HowManyRows * howManyFitInRow;
		}
		
		var animate = function() {
			requestID = requestAnimationFrame(animate);

			// If the box has not reached the end draw on the canvas.
			// Otherwise stop the animation.
			if(isDemo){
				if (i < limit) {
					
					if(i % howManyFitInRow === 0 && i !== 0){
						aux2 = 0;
						filaPointer--;
					}
	
					if(personIcons[(filaPointer * howManyFitInRow - howManyFitInRow) +  aux2]){
						$(personIcons[(filaPointer * howManyFitInRow - howManyFitInRow) +  aux2]).addClass("red");
						aux2++;
						pintados++;
					}
	
					if(pintados === maxValue){
						i = limit;
					}else{
						i++;
					}
				} else {
					cancelAnimationFrame(requestID);
				}
			}else{
				if (i < maxValue) {
					$(personIcons[i]).addClass("red");
					i++;
				} else {
					cancelAnimationFrame(requestID);
				}
			}
		}

		animate();
	}

	/**
	 * Animates the pictographic icons whenever there's a change of filter
	 * 
	 * @param {any} personIcons 
	 * @param {any} maxValue 
	 * @param {any} isDemo 
	 */
	function _animatePictographicChartInitial(personIcons, maxValue, isDemo) {
		var i = 0;
		//animate person
		var requestID;

		var animate = function() {
			requestID = requestAnimationFrame(animate);

			// If the box has not reached the end draw on the canvas.
			// Otherwise stop the animation.
			if (i < maxValue) {
				var index = isDemo ? (personIcons.length - 1) - i : i;
				$(personIcons[index]).removeClass("picto-hidden");
				i++;
			} else {
				cancelAnimationFrame(requestID);
			}
		}

		animate();
	}

	//public functions

	/**
		Initializes all the variables, listeners, etc of the 
		Data module instance
	*/
	function init(settings) {

		//console.log("settings", settings);

		chartId = settings.id;
		chartConfig = settings;

		//defines what type of chart should be used in Chart.js
		nonDemographicChartType = settings.horizontalType;
		demographicChartType = settings.verticalType;

		//we query every part of the template
		$container = $("#"+chartId+".chart-main-container");
		$form = $container.find(".chart-filter");
		//non demographic
		$nonDemographicChart = $container.find(".non-demographic-charts");
		$nonDemographicBars = nonDemographicChartType == "horizontalBar" ? $container.find("[class^='bar-horizontal-']") : $container.find("[class^='donut-horizontal-']") ;
		$nonDemographicTooltip = $container.find(".custom-tooltip-non-demographic");
		//demographic
		$demographicChart = $container.find(".demographic-charts");
		$demographicBars = demographicChartType == "bar" ? $container.find("[class^='bar-vertical-']") : $container.find("[class^='bar-demo-horizontal-']");
		$demographicTooltip = $container.find(".custom-tooltip-demographic");

		$toggles = $container.find(".toggle-container .switch");
		$checkboxes = $container.find(".checkbox-container .checkbox");


		//if there's only one checkbox then there's no reason to show it
		if(chartConfig.checkboxes.length === 1){
			//Since there is one for each set of graphs we need to hide them all
			$($checkboxes).hide();
		}


		//initialize slider if type 7
		if(chartConfig.type === 7){
			$nonDemoPictoContainer = $container.find(".horizontal-charts .pictograph-slider-container");
			$demoPictoContainer = $container.find(".vertical-charts .pictograph-slider-container");

			
			$nonDemoPictoContainer.slick({
				infinite: false,
				draggable: false,
				dots:true,
				speed: 0,
				prevArrow: "<button class='nav-arrow prev-arrow first'></button>",
				nextArrow: "<button class='nav-arrow next-arrow'></button>",
			});

			$demoPictoContainer.slick({
				infinite: false,
				draggable: false,
				dots:true,
				speed: 0,
				prevArrow: "<button class='nav-arrow prev-arrow first'></button>",
				nextArrow: "<button class='nav-arrow next-arrow'></button>",
			});


			$(window).on("resize", function () {
				$demoPictoContainer.find(".person-picto-container:not(.row-disabled)").each(function () {
					_reColorPictographsVertical($(this).find(".person-picto.person-svg"));
				});
			});
		
		}


		//when the dropdown is changed, we need to redraw the charts
		$form.find("select").on("change", function() {
			_destroyChartInstances();
			activeDemoCheckboxGroup = undefined;

			/**
				If theres a toggle that depends on the selected option we need to show the correct one
				and hide the other(s)
			*/
			var dropdownName = $(this).attr("name");
			var selectedOption = $(this).val();

			for (var j = 0; j < chartConfig.toggles.length; j++) {
				if(chartConfig.toggles[j].showIf && chartConfig.toggles[j].showIf.filter === dropdownName){ //it the toggle does not have the showIf, then we always have to show it
					if(chartConfig.toggles[j].showIf.equals === selectedOption){
						$($toggles[j]).find("input").prop("checked", false).trigger("change");
						$($toggles[j]).addClass("visible");

					}else{
						$($toggles[j]).removeClass("visible");
						$($toggles[j]).find("input").prop("checked", false).trigger("change");
					}
				}
			}

			/**
				When the demografic option is selected,
				show vertical charts, else show horizontal
			*/
			if ($form.find("select[name=demo]").val().length) {
				_updateVerticalCharts();
			} else {
				_updateHorizontalCharts();
			}
		});

		if($toggles.length){
			$toggles.each(function (i, el) {
				var input = $(el).find("input.switch-input");
				var inputId = $(input).attr("id");
				input.change(function() {

					if(!$(this).parent().hasClass("visible")) return;

					_destroyChartInstances();

					if ($form.find("select[name=demo]").val().length) {
						_updateVerticalCharts();
					} else {
						_updateHorizontalCharts();
					}

				});

				input.trigger("change");
			});
		}

		if($checkboxes.length){
			var lastCheckedOfSiblings = true; //checks if this is the last checked checkbox in siblings
			
			$checkboxes.each(function (i, el) {
				var checkbox = $(el).find("input[type='checkbox']");
				var checkboxId = $(checkbox).attr("id");

				checkbox.change(function() {

					/*
						if the current checkbox is the last of siblings we don't do nothing
					*/
					if(lastCheckedOfSiblings) return;
					_destroyChartInstances();

					if ($form.find("select[name=demo]").val().length) {
						_updateVerticalCharts();
					} else {
						_updateHorizontalCharts();
					}
				});

				//tes
				checkbox.click(function () {
					var currCheckbox = $(this);
					var currCheckboxId = $(this).attr("id");
					var numberOfCheckedSiblings = 0;

					/*
					Variable that tells the module wich of the active checbox group is active(meaning, recently cliked),
					so that the proper Demographic charts get redrawn
					*/
					var checkboxGroup = $(this).parent().parent().parent().parent().attr("data-checkbox-group");
					activeDemoCheckboxGroup = checkboxGroup ? parseInt(checkboxGroup) : undefined;

					/*first check if the checkbox clicked is the last one of group, if it is
					then we need to not allow the update (vert|hor) charts function to run
					*/
					var checkboxSiblings = $(this).parent().parent().find(".checkbox input[type='checkbox']");
					$.each(checkboxSiblings, function (i) {
						if($(this).attr("id") !== currCheckboxId && $(this).is(":checked")) numberOfCheckedSiblings++;
					});

					if(numberOfCheckedSiblings === 0){
						//We re-put the value that was before in the checkbox, to give the illusion that the checkbox never changed
						$(this).attr("checked", !$(this).is(":checked"));
						lastCheckedOfSiblings = true;
					}else{
						lastCheckedOfSiblings = false;
					}

				});

				checkbox.trigger("change");
			});
		}

		/**
			when yo hover on the horizontal bars the variable hoveredHorizontalBar grabs the
			canvas you;re currently hovering, so that the tooltip can show the correct info
			on 'mouseout' it returns to null and because your'e not hovering, then it should
			hide the tooltip.
		*/
		$($nonDemographicBars).hover(
			function () {
				hoveredHorizontalBar = $(this);
			},
			function () {
				hoveredHorizontalBar = null;
				$nonDemographicTooltip.css("visibility", "hidden");
			}
		);
		/**
			Same for vertical
		*/
		$($demographicBars).hover(
			function () {
				hoveredVerticalBar = $(this);
			},
			function () {
				hoveredVerticalBar = null;
				$demographicTooltip.css("visibility", "hidden");
			}
		);


		_calculateMeasurements($(window));

		//when the user resizes the window, then update charts acordingly for responsive design
		$(window).resize(function () {
			_calculateMeasurements(this);

			//reset tooltip states
			$demographicTooltip.css("visibility", "hidden");
			$nonDemographicTooltip.css("visibility", "hidden");
			
		});

		// initialize chart on load (or if it's scrolled into view)
		//_initializeAnimation();
	}

	/**
		It indicates which of the charts are shown in the 
		moment of calling the function
	*/
	function currentlyShownChart() {
		if($form.find("select[name='demo']").val() === ""){
			return "horizontal";
		}else{
			return "vertical";
		}
	}

	/**
		Gets the index of the dataset that's being hovered over,
		it's important for two things: showing/hiding the tooltip on vertical charts,
		and highlighting the stacked bars
	*/
	function getCurrentlyHoveredItemIndex() {
		return currentlyHoveredItemIndex;
	}

	//Returns the type # (design) of the chart 
	function getChartType() {
		return chartConfig.type;
	}

// explicitly return public methods when this object is instantiated
return {
	init: init,
	currentlyShownChart: currentlyShownChart,
	getCurrentlyHoveredItemIndex: getCurrentlyHoveredItemIndex,
	getChartType: getChartType,
	run : _initialize
};

} );